import React from "react";
import "./Hero.css";
import Header from "../Header/Header";
import hero_image from "../../assets/younis.png";
import hero_image_back from "../../assets/hero_image_back.png";
import Calories from "../../assets/player.png";
import heart from "../../assets/heart.png";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";
const Hero = () => {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />
        {/*the best  ad */}
        <div className="the-best-ad">
          <motion.div
            initial={{ left: mobile ? "165px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span> Bocca : Academie de football</span>
        </div>
        {/*Hero Heading*/}
        <div className="hero-text">
          <div>
            <span className="stroke-text">L'émulation</span> <span>est</span>
          </div>
          <div>
            <span>l'essence du football</span>
          </div>
          <div>
            <span>
              Bocca Football Academy est une académie tunisienne de football
              située à Tunis (Mhamdia, Fouchena). Nous accueillons des joueurs
              âgés de 4 à 23 ans qui cherchent à se former . Nous offrons un
              programme complet qui allie études et sports pour une formation
              complète et intégrale des joueurs du futur.{" "}
            </span>
          </div>
        </div>

        {/*figures*/}
        <div className="figures">
          <div>
            <span>
              <NumberCounter end={4} start={1} delay="2" preFix="+" />
            </span>
            <span>COACH EXPERTS</span>
          </div>
          <div>
            <span>
              <NumberCounter end={100} start={10} delay="2" preFix="+" />
            </span>
            <span>JOUEURS REJOINTS</span>
          </div>
          <div>
            <span>
              <NumberCounter end={50} start={1} delay="2" preFix="+" />
            </span>
            <span>programmes de football</span>
          </div>
        </div>
        {/*Hero Buttons*/}
        <div className="hero-buttons">
          <button className="btn">Commencer</button>
          <button className="btn">Plus</button>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">Rejoignez-nous</button>

        <motion.div
          initial={{ right: "-1rem" }}
          transition={transition}
          whileInView={{ right: "4rem" }}
          className="heart-rate"
        >
          <img src={heart} alt="" />
          <span style={{ color: "white" }}>NO RACISM</span>
          <span>PEACE</span>
        </motion.div>
        {/*Hero images*/}
        <img src={hero_image} alt="" className="hero-image" />
        <motion.img
          initial={{ right: "11rem" }}
          transition={transition}
          whileInView={{ right: "20rem" }}
          src={hero_image_back}
          alt=""
          className="hero-image-back"
        />
        {/*calories*/}
        <motion.div
          initial={{ right: "37rem" }}
          transition={transition}
          whileInView={{ right: "28rem" }}
          className="calories"
        >
          <img src={Calories} alt="" />
          <div>
            <span>Meilleur Joueur</span>
            <span>8 Buts</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
